import { THREE} from 'three-edit-cores'
import { ConvexGeometry } from 'three/addons/geometries/ConvexGeometry.js';
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader.js'
import {CustomMould} from '../../types/datatypes'
class PointsMesh extends CustomMould{
   create(_params,{scene}){
    Object.assign(this.params,_params)
     if(this.params.url==''){
      this.params.url=window.prompt('点云ply文件地址')
     }
     if(!this.params.url){
       return
     }
    const loader = new PLYLoader()
       loader.load(this.params.url,geometry=>{
        var points=[]

       const positionAttribute = geometry.attributes.position;
       for(var i=0;i<positionAttribute.count;i++){
        const x = positionAttribute.getX(i);
        const y = positionAttribute.getY(i);
        const z = positionAttribute.getZ(i);
         points.push(new THREE.Vector3(x, y, z))
       }
      const geometrymesh = new ConvexGeometry( points )
      geometrymesh.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(geometrymesh.attributes.position.count * 2), 2));
       geometrymesh.attributes.uv.needsUpdate = true;

      geometrymesh.computeVertexNormals();
      var texture=null
       if(this.params.image){
          texture=new THREE.TextureLoader().load(this.params.image)
          texture.repeat.set( 1, 1 )
        }
        const materialmesh = new THREE.MeshBasicMaterial( {
          color: this.params.color,
          map:texture,
          //envMap:texture,
          side: THREE.DoubleSide,
          //wireframe: true //显示为网格
        });
        const mesh = new THREE.Mesh( geometrymesh, materialmesh )
        scene.add( mesh )
      })
      return null
  }
}
const pointmesh=new PointsMesh('pointsmesh','点云模型')
pointmesh.format={
  color:{domtype:'color',name:'模型颜色',change(mesh,v){
    mesh.material.color=v
  }},
  color:{name:'贴图',change(mesh,v){
     if(v){
      var texture=new THREE.TextureLoader().load(this.params.image)
          texture.wrapS=1
          texture.wrapT=1
          texture.repeat.set( 1, 1 )
      mesh.material.map=texture
     }
  }}
}
export default  pointmesh
